<script setup>
import EyeIcon from '@iconify-vue/ph/eye';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';

const { href, target = undefined } = defineProps({
    href: {
        type: String,
        required: true,
    },
    target: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <BaseCell>
        <ActionButton
            :href="href"
            :target="target"
            type="secondary"
            :icon="EyeIcon"
            size="small"
            class="size-8"
        />
    </BaseCell>
</template>
